import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { of, throwError, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { catchError, map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import * as CryptoJS from "crypto-js";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  option: any;
  data: any;
  id: any;
  language: any;
  encryptedData: any;
  isLoading: boolean;
  contentName: any;
  uploadedFile: any;
  constructor(private http: HttpClient, private toastrService: ToastrService) {
    this.encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.encryptedData) {
      this.encryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + this.encryptedData.token)
        .set("Content-Type", "application/x-www-form-urlencoded");
      this.option = { headers };
    }
  }

  updateToken(): void {
    this.language = JSON.parse(
      localStorage.getItem(environment.localStorageLangKey)
    );
    this.encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.encryptedData) {
      this.encryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      const headers = new HttpHeaders()
        .set("language", this.language)
        .set("Authorization", "Bearer " + this.encryptedData.token)
        .set("Content-Type", "application/x-www-form-urlencoded");
      this.option = { headers };
    }
  }
  ProfileDetail(): any {
    this.updateToken();
    return this.http.get(environment.apiUrl + "get_profile", this.option);
  }

  /**
   * Edit Profile
   */

  EditProfile(data): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("name", data.name)
      .set("email", data.email.toLowerCase())
      .set("mobile_number", data.mobile_number)
      .set("gender", data.gender)
      .set("date_of_birth", moment(data.date_of_birth).format("YYYY-MM-DD"))
      .set("image", data.image);

    return this.http
      .put(environment.apiBaseUrl + "update_profile", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.error,
          });
        })
      );
  }

  uploadImage(data: any): Observable<any> {
    this.updateToken();
    const latestFile =
      Math.floor(100000 + Math.random() * 900000) +
      "." +
      data.name.split(".").pop();

    const imageData = {
      fileName: "temp/" + latestFile,
      fileType: data?.type,
    };

    return this.http
      .post(
        environment.uploadApiUrl + "uploads",
        JSON.stringify(imageData),
        this.option
      )
      .pipe(
        map((data) => {
          data
            ? setTimeout(() => {
                this.contentName = imageData.fileName.split(".").pop();
                this.uploadedFile = environment.imgPreview + imageData.fileName;
              }, 200)
            : " ";
          return data;
        })
      )
      .pipe(
        catchError((err) => {
          this.handleError(err);
          return of({ status: err.status, message: err.error });
        })
      );
  }
  uploadFileToS3(data: any, file: any): Observable<any> {
    let headers: any = new Headers();
    headers = {
      headers: {
        "Content-Type": file?.type,
      },
    };
    return this.http
      .put(data?.url, file, headers)
      .pipe(
        map((res) => {
          // res ? (this.progressBar = true) : (this.progressBar = false);
          return res;
        })
      )
      .pipe(
        catchError(() => {
          return of(null);
        })
      );
  }
  getOtp(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("country_code", data.code)
      .set("mobile_number", data.mobile)
      .set("country", data.country_name);

    return this.http
      .post(
        environment.apiUrl + "updateMobileNumber/sendOtp",
        body,
        this.option
      )
      .pipe(
        catchError((err) => {
          return throwError(err);
        })
      );
  }
  updateMobileNumber(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("OTP_token", data.token)
      .set("code", data.oTP);
    return this.http.post(
      environment.apiUrl + "updateMobileNumber",
      body,
      this.option
    );
  }

  /**
   * Error handler
   */
  handleError(error: any): any {
    this.isLoading = false;
    if (error.status === 403) {
      this.toastrService.error("error", error.message);
    } else if (error.status === 404) {
      this.toastrService.error("error", error.error.message);
    } else if (error.status === 500) {
      this.toastrService.error("error", error.statusText);
    } else if (error.status === 0) {
      this.toastrService.error("error", error.statusText);
    } else if (error.status === 422) {
      this.toastrService.error("error", error.error.message);
    } else if (error.status === 401) {
      this.toastrService.error("error", error.error.type);
    } else if (error.status === 409) {
      this.toastrService.error("error", error.error.message);
    }
    return throwError(error);
  }
}
